import React, { useState } from 'react';
import './AdminDataTask.scss';
import { setAdminDataTaskView } from '../../../adminSlice';
import { addNewQuiz, updateQuizTask, setOpenDeleteQuizTaskForm } from '../../../../MainVIew/Tasks/taskSlice';
import DeleteQuizTaskForm from '../DeleteQuizTaskForm';

const AdminDataTask = (props) => {
    
    const [newOrder, setNewOrder] = useState('');
    const [addQuizView, setAddQuizView] = useState(false);

    const [selectedQuizId, setSelectedQuizId] = useState();
    const [selectedQuizName, setSelectedQuizName] = useState('');

    //const [selectedLastQuizId, setSelectedLastQuizId] = useState();
    //const [selectedLastQuizName, setSelectedLastQuizName] = useState('');
    

    const [selectedCategoryId, setSelectedCategoryId] = useState();
    const [selectedCategoryName, setSelectedSubCategoryName] = useState('');

    const [selectedSubCategoryId, setSelectedSubCategoryId] = useState();
    const [selectedSubCategoryName, setSelectedCategoryName] = useState('');

    const [editQuizView, setEditQuizView] = useState(false);
    const [checkQuizView, setCheckQuizView] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    
   
    const {dispatch} = props;
    //HADLE CHOOSE CATEGORY
    /*const onEditQuizView = () => {
       // setEditQuizView(!editQuizView);
        setCheckQuizView(!checkQuizView);

        setSelectedQuizId(selectedLastQuizId);
        setSelectedQuizName(selectedLastQuizName);
        setSelectedLastQuizId(selectedQuizId);
        setSelectedLastQuizName(selectedQuizName);
    }*/
    const handleChooseCategory = (event) => {
        const selectedCategoryName =event.target.options[event.target.selectedIndex].text;
        const selectedCategoryId =Number(event.target.options[event.target.selectedIndex].value);
        setSelectedCategoryId(Number(selectedCategoryId));
        setSelectedCategoryName(selectedCategoryName);

        setSelectedQuizId();
        setSelectedQuizName('');
        setSelectedSubCategoryId();
        setSelectedSubCategoryName('');
        document.getElementById("select-subcategory").selectedIndex = 0;
        document.getElementById("select-quiz").selectedIndex = 0;
        

    }
        //HADLE CHOOSE SUBCATEGORY
    const handleChooseSubCategory = (event) => {
        const selectedSubCategoryName =event.target.options[event.target.selectedIndex].text;
        const selectedSubCategoryId =Number(event.target.options[event.target.selectedIndex].value);
        setSelectedSubCategoryId(Number(selectedSubCategoryId));
        setSelectedSubCategoryName(selectedSubCategoryName);

        setSelectedQuizId();
        setSelectedQuizName('');
        document.getElementById("select-quiz").selectedIndex = 0;
    }
            //HADLE CHOOSE QUIZ
    const handleChooseQuiz = (event) => {
        const selectedQuizName =event.target.options[event.target.selectedIndex].text;
        const selectedQuizId =Number(event.target.options[event.target.selectedIndex].value);
        setSelectedQuizId(selectedQuizId);
        setSelectedQuizName(selectedQuizName);
        setErrorMessage('');
    }
    // HANDLE EXIT TASK
    const onClickEnd = () => {
        props.handleAdminTasksView();
        dispatch(setAdminDataTaskView());
    }

    //ADD NOTE TO TASK
    const onClickAddNoteToTaskView = () => {

        setAddQuizView(true);
        //setEditQuizView(true);
        setCheckQuizView(true);
    }
    //ADD NEW TASK
    const onClickAddNoteToTask = () => {

        const data = {
            quizId: selectedQuizId,
            taskId: props.tasksDataMain.selectedTaskIdForQuizes,
            orderType: newOrder
        }
        
            console.log ('add quiz task');
            if (!newOrder || !selectedQuizId) {
                setErrorMessage('Введите исходные данные')
            } else {
            dispatch(addNewQuiz(data));
        

         
        //CLEAR
        cleanFunction();
        } 
    }

        //SAVE TASK
    const onClickSaveNoteToTask = () => {

        const data = {
            quizId: selectedQuizId,
            taskId: props.tasksDataMain.selectedTaskIdForQuizes,
            orderType: newOrder,
           
        }
        
            console.log ('update quiz task');
            if (!newOrder || !selectedQuizId) {
                setErrorMessage('Введите исходные данные')
            } else {
            dispatch(updateQuizTask(data));
            //console.log('edit quiz task!');
            console.log(data);    
         
        //CLEAR
        cleanFunction();
        } 
    }

    //CLEAR INPUT FORMS
    const onClickClear = () => {
        cleanFunction();

    }
    //  EDIT NOTE
    const onEditNote = (e) => {
        setSelectedQuizId(Number(e.target.value));
        setSelectedQuizName(e.target.dataset.value1);
        setEditQuizView(true);
    }
    //  DELETE  NOTE
    const onDeleteNote = (e) => {
         setSelectedQuizId(Number(e.target.value));
       
        dispatch(setOpenDeleteQuizTaskForm());
    
    }
    // CLEAN DATA FORMS FUNCTION
    const cleanFunction = () => {
        setAddQuizView(false);
        setSelectedQuizId();
        setEditQuizView();
        setCheckQuizView();
        setSelectedQuizName('');
             
     
        setSelectedCategoryId();
        setSelectedCategoryName('');
        setSelectedSubCategoryId();
        setSelectedSubCategoryName('');
        setNewOrder('');
        setErrorMessage('');
        

        document.getElementById("select-category").selectedIndex = 0;
        document.getElementById("select-subcategory").selectedIndex = 0;
        document.getElementById("select-quiz").selectedIndex = 0;
    }
    //RENDER OPTIONS FOR CATEGORY
       const renderOptionsCategory = () => {
        let data = props.tasksDataMain.categoryData;
       // console.log(data);
        if (data.length !== 0) {
            return (
                data.map((item, index) => {
                    return (
                        <option key={index} value={item.id} >{item.label}</option>
                        )
                }

                )
            );
        };
    } 
        //RENDER OPTIONS FOR SUBCATEGORY
       const renderOptionsSubCategory = () => {
        let data = props.tasksDataMain.subcategoryData;
        let resultData = [];

        const findData = (array) => {

            array.forEach(item => {
                if (item.main_id === selectedCategoryId) {
                   // console.log(item.main_id);
                   // console.log(selectedCategoryId);
                    resultData.push(item);
                }
            });
        };

        findData(data);

       // console.log(resultData);

        if (resultData.length !== 0) {
            return (
                resultData.map((item, index) => {
                    return (
                        <option key={index} value={item.sub_id} >{item.text}</option>
                        )
                }

                )
            );
        };
    }
            //RENDER OPTIONS FOR QUIZES
       const renderOptionsQuizes = () => {
        let data = props.tasksDataMain.quizesData;
        let resultData = [];

        const findData = (array) => {

            array.forEach(item => {
                if (item.sub_id === selectedSubCategoryId) {
                   // console.log(item.sub_id);
                  //  console.log(selectedSubCategoryId);
                    resultData.push(item);
                }
            });
        };

        findData(data);

        console.log(resultData);

        if (resultData.length !== 0) {
            return (
                resultData.map((item, index) => {
                    return (
                        <option key={index} value={item.quiz_id} >#{item.quiz_id} {item.text}</option>
                        )
                }

                )
            );
        };
    }
//HANDLE SET ORDER
  const handleSetOrder = (e) => {     
        const newOrder = e.target.value;
        setNewOrder(newOrder);
        setErrorMessage('');
}           
//RENDER TASK DATA
    const renderDataTask = () => {

        const tasksDataMain = props.tasksDataMain.tasksDataMain;
       // console.log(tasksDataMain);
        //console.log(typeof(idTrouble));
        
        //FIND CONTENT FOR TASK
        let resultArrayTaskData = [];
            if (tasksDataMain.length !== 0) {
                tasksDataMain.forEach(element => {
                    
                if (element.taskId === Number(props.tasksDataMain.selectedTaskIdForQuizes)) {
                    resultArrayTaskData.push(element);
                }

                }); 
            };
           //  console.log(resultArrayTaskData);
        //RENDER CONTENT FOR TASK

        if (resultArrayTaskData.length !== 0) {
            let contentForTask = resultArrayTaskData[0].taskData;
                      //  console.log(contentForTask);
            return (
                contentForTask.map( (item, index) => {
                                  //  console.log(item);
                                    
                                return (

                                    
                                <div className='container-row' key={index}>
                                    <button className="note-button" disabled> {item.order_type}. #{item.quiz_id}  {item.quiz_name}</button>
                                    <button className={item.quiz_id !== selectedQuizId ?'smallbtnEdit':'smallbtnEdit-selected'} value={item.quiz_id} data-value1={item.quiz_name}  onClick={onEditNote}></button>
                                    <button className='smallbtnDelete' value={item.quiz_id} onClick={onDeleteNote}></button>
                                </div>
                                )
                                }
                            )
                    );
                } else return null;                    
    }

       // const view = props.viewTasks;
       // if(view) {
            return (
            
                <div className="AdminDataTask">
                    <div className="container-row">
                       <button className="exit" onClick={onClickEnd}></button>
                       <p className='main-header'> Задача</p>
                    </div>
                    <div className='main-container'>
                        <div className='group-left'>
                            <div className="container-column">
                               {/* <label htmlFor="checkbox">Редактировать Заметку</label>

                                
                                <input  className="check-box" type="checkbox"  disabled ={editQuizView ? '' : 'disabled' } onChange={onEditQuizView} checked={!checkQuizView ? '' : 'checked'}></input>
                                <label htmlFor="title">Выбрать Заметку для Задачи</label>*/}
                                <input name="title" placeholder={`#${selectedQuizId ? selectedQuizId : ''} ${selectedQuizName}`}  disabled></input>
                            </div> 
                            <div className="container-column">
                                    <label >Выберите категорию</label>
                                    <select name="category" id="select-category" defaultValue={"Default"}  value={selectedCategoryId} onChange={handleChooseCategory} disabled ={checkQuizView ? '' : 'disabled'}>
                                        <option disabled  value="Default"></option>
                                        {renderOptionsCategory()}

                                    </select>
                                    <label htmlFor="subcategory">Выберите подкатегорию</label>
                                    <select name="subcategory" id="select-subcategory" defaultValue={'Default'} value={selectedSubCategoryId} onChange={handleChooseSubCategory} disabled ={checkQuizView ? '' : 'disabled'}>
                                        <option disabled  value="Default"></option>
                                       {renderOptionsSubCategory()}

                                    </select>
                                    <label htmlFor="quiz">Выберите Заметку</label>
                                    <select name="quiz" id="select-quiz" defaultValue={'Default'} value={selectedQuizId} onChange={handleChooseQuiz} disabled ={checkQuizView ? '' : 'disabled'}>
                                        <option disabled  value="Default"></option>
                                        {renderOptionsQuizes()}

                                    </select>
                            </div>
                            <div className="container-column">
                                <label htmlFor="count">Назначить порядковый номер для Заметки</label>
                                <input className="count" name="count" placeholder='0' value={newOrder} onChange={handleSetOrder} disabled ={(addQuizView || editQuizView )? '' : 'disabled'}></input>
                                <p className='error-message'>{errorMessage}</p>
                            </div>

                            <div className="container-row">
                                <button className='common-button' onClick={onClickAddNoteToTask} disabled ={addQuizView? '' : 'disabled'}>Добавить</button>
                                
                                 <button className='common-button' onClick={onClickSaveNoteToTask} disabled ={editQuizView? '' : 'disabled'}>Сохранить</button>
                                 <button className='common-button' onClick={onClickClear} disabled ={(addQuizView || editQuizView)? '' : 'disabled'}>Отмена</button>
                            </div>

                        </div>
                        <div className='group-right'>
                            <button className="task-button" >#{props.tasksDataMain.selectedTaskIdForQuizes} {props.tasksDataMain.selectedTaskNameForQuizes}</button>
                            {renderDataTask()}
                            <div>
                                <button className='common-button' onClick={onClickAddNoteToTaskView} disabled ={!editQuizView ? '' : 'disabled'}>Добавить</button>
                            </div>
                        </div>
                    </div>
                    {props.tasksDataMain.openDeleteQuizTaskForm ? <DeleteQuizTaskForm
                        dispatch={dispatch}
                        onClickClear = {onClickClear}
                        taskId={props.tasksDataMain.selectedTaskIdForQuizes}
                        quizId={selectedQuizId}
                        /> : null}
                </div>
            )
       // } else return null;
        

    
}
export default AdminDataTask;